import { observer } from "mobx-react-lite";
import AnalyticIncidentData from "../../../../../api/AnalyticIncidentData";
import stateAnalyticApp from "../../../../../state/stateAnalyticApp";
import { AnalyticsIncidentCardSkeleton } from "../../skeletons/AnalyticsIncidentCardSkeleton";
import { formatIsoDateShortDisplay } from "../../../../../utils/subscriptionPeriodDate";

export const CardIncident = observer(() => {
  const filterDevice = (p, l, d) => {
    AnalyticIncidentData.changeFilterDevice(p.production_id, l.place_id, d);
  };

  const setVisibleProduction = (production_id) => {
    AnalyticIncidentData.changeVisibleProduction(production_id);
  };

  const setVisibleLine = (production_id, place_id) => {
    AnalyticIncidentData.changeVisibleLine(production_id, place_id);
  };

  const cardData = AnalyticIncidentData.incidentCard.data ?? [];
  const isCardLoading = !stateAnalyticApp.isLoading && cardData.length === 0;

  const renderCardBody = () => {
    if (isCardLoading) {
      return <AnalyticsIncidentCardSkeleton />;
    }

    if (cardData.length === 0) {
      return <p className="grey_info">Детали инцидента не найдены</p>;
    }

    return cardData.map((p) => (
      <div key={p.production_id} className="card_incident_production">
        <div className="card_incident_production_title">
          <span>Площадка: {p.name_production}</span>
          <div className="card_incident_header_meta_row">
            <span className="card_incident_header_text_span">
              Кол-во ошибок:{" "}
            </span>
            {p.production_errors}
          </div>
          <button
            type="button"
            onClick={() => setVisibleProduction(p.production_id)}
            className="card_incident_title_action"
            aria-expanded={p.visible}
          >
            {p.visible ? "свернуть" : "развернуть"}
          </button>
        </div>
        {p.visible &&
          p.places.map((l) => (
            <div key={l.place_id}>
              <div className="card_incident_line_info">
                <div className="card_incident_production_title">
                  <span>Линия: {l.place_name}</span>
                  {l.filter_device !== null ? (
                    <label className="card_incident_title_filter_container">
                      <span className="card_incident_title_filter">
                        фильтер по {l.filter_device}
                      </span>
                      <span
                        className="card_incident_title_filter_remove"
                        onClick={() =>
                          AnalyticIncidentData.changeFilterDevice(
                            p.production_id,
                            l.place_id
                          )
                        }
                      >
                        x
                      </span>
                    </label>
                  ) : null}
                  <div className="card_incident_header_meta_row">
                    <span className="card_incident_header_text_span">
                      Кол-во ошибок:{" "}
                    </span>
                    {l.place_errors}
                  </div>
                  <button
                    type="button"
                    onClick={() => setVisibleLine(p.production_id, l.place_id)}
                    className="card_incident_title_action"
                    aria-expanded={l.visible}
                  >
                    {l.visible ? "свернуть" : "развернуть"}
                  </button>
                </div>
                <div className="card_incident_line_data">
                  {l.visible &&
                    l.data.map((d) => (
                      <div
                        className="card_incident_line_data_item card_incident_line_data_item_text"
                        key={d.index}
                      >
                        <div
                          onClick={() => filterDevice(p, l, d)}
                          className="card_incident_line_data_item_text_device"
                        >
                          <span className="card_incident_header_text_device_span">
                            Оборудование:
                          </span>{" "}
                          {d.device_name}
                        </div>
                        <div className="card_incident_line_data_item_text_task">
                          <span className="card_incident_header_text_device_span">
                            Задание:
                          </span>{" "}
                          {d.taskid}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          ))}
      </div>
    ));
  };

  return (
    <div className="card_incident_container">
      <div className="card_incident_header">
        <div className="card_incident_header_text">
          <div>
            <span className="card_incident_header_text_span">Инцидент: </span> "
            {AnalyticIncidentData.incidentCard.name}"
          </div>
          <div>
            <span className="card_incident_header_text_span">Период: </span> с{" "}
            {formatIsoDateShortDisplay(stateAnalyticApp.from_date)} по{" "}
            {formatIsoDateShortDisplay(stateAnalyticApp.to_date)}
          </div>
          <div className="card_incident_header_meta_row">
            <span className="card_incident_header_text_span">
              Кол-во ошибок:{" "}
            </span>
            {AnalyticIncidentData.incidentCard.count}
          </div>
          <div className="card_incident_header_meta_row">
            <span className="card_incident_header_text_span">
              Время простоя:{" "}
            </span>
            {AnalyticIncidentData.incidentCard.time}
          </div>
        </div>
        <button
          type="button"
          className="card_incident_header_closed_btn"
          aria-label="Закрыть"
          onClick={() => AnalyticIncidentData.incidentCardVisible(false)}
        >
          X
        </button>
      </div>
      <div className="card_incident_body">{renderCardBody()}</div>
    </div>
  );
});
